// client/src/components/seller/GroupProductPickerModal.js
import React, { useState, useEffect } from 'react';
import {
  fetchAvailableProducts,
  assignProductToGroup,
} from '../../services/groupService';
import ProductThumbnail from './ProductThumbnail';
import useDialogFocus from '../../hooks/useDialogFocus';

function GroupProductPickerModal({ seller, group, onClose, onAssign }) {
  const [loading, setLoading] = useState(true);
  const dialogRef = useDialogFocus(true, onClose);
  const [products, setProducts] = useState([]); // изначально пустой массив

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setProducts([]); // сбрасываем перед загрузкой
    (async () => {
      try {
        const res = await fetchAvailableProducts(seller.id, group.subcategory);
        if (!cancelled) {
          // res.data может быть массивом или объектом с полем data/items
          const data = Array.isArray(res) ? res : res?.data || res?.items || [];
          setProducts(data);
        }
      } catch (err) {
        console.error(err);
        if (!cancelled) setProducts([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [seller.id, group.subcategory]);

  const handleAdd = async (productId) => {
    try {
      await assignProductToGroup(
        productId,
        seller.id,
        group.id,
        group.subcategory
      );
      onAssign();
      onClose();
    } catch (err) {
      alert('Ошибка: ' + (err.response?.data?.error || err.message));
    }
  };

  // Безопасная проверка длины: products гарантированно массив
  const isEmpty = products.length === 0;

  return (
    <div className="modal-overlay">
      <button
        className="modal-backdrop"
        aria-label="Закрыть выбор товара"
        tabIndex={-1}
        onClick={onClose}
      />
      <div
        ref={dialogRef}
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-label="Выбор товара для группы"
        tabIndex={-1}
        style={{ maxWidth: 500, width: '90%' }}
      >
        <button
          className="modal-close"
          aria-label="Закрыть выбор товара"
          onClick={onClose}
        >
          ✕
        </button>
        <h3>Выберите товар для группы «{group.name}»</h3>
        <p style={{ fontSize: 14, color: '#64748b', marginBottom: 12 }}>
          Подкатегория: {group.subcategory}
        </p>
        {loading ? (
          <p>Загрузка...</p>
        ) : isEmpty ? (
          <p>Нет доступных товаров этой подкатегории без группы.</p>
        ) : (
          <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            {products.map((product) => (
              <div
                key={product.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '8px 0',
                  borderBottom: '1px solid #f1f5f9',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <ProductThumbnail product={product} size={40} />
                  <div>
                    <div style={{ fontWeight: 600 }}>{product.title}</div>
                    <div style={{ fontSize: 12, color: '#64748b' }}>
                      Арт. {product.publicArticle || product.platformSku || product.platform_sku}
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => handleAdd(product.id)}
                  className="btn btn-primary"
                  style={{ padding: '4px 12px' }}
                >
                  Добавить
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default GroupProductPickerModal;
